import { SearchTextField } from '../../ResuableComponent/CustomModal/TextFields/TextFields';
import './SelectedModuleModal.scss';
import LibrarySearchIcon from "../../../images/library-searchIcon.svg";
import { useEffect, useRef, useState } from 'react';
import GreenTickMark from '../../../images/MLR StatusGreen.png';
import NotApprovedImage from '../../../images/not-approved-image.svg';
import InfoIcon from '../../../images/warning.svg';
import EmptyImage from '../../../images/EmptyImage.svg';
import { getmmModules, getModuleCardDetails, getSelectedModulecardDetails } from '../../../services/apis';
import CircularProgressBar from '../../../utils/CircularProgressBar';
import ModuleView from '../ModulePreview/ModuleView';
// import { selectAll } from '@codemirror/commands';

const SelectedModuleModal = ({selectedModuleIds, moduleCardList, moduleData}) => {
    const [customPlaceholder, setCustomPlaeHoder] = useState(true);
    const [ruleCategories, setCustomDetails] = useState([
        { label: 'Must exist with (Compliance)', condition: 'MustExistWith' },
        { label: 'Cannot exist with (Compliance)', condition: 'CannotExistWith' },
        { label: 'Related Modules (Optional)', condition: 'Optional' }
    ]);
    const [inputValue, setInputValue] = useState('');
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [filterdCard, setFilteredCard] = useState();
    const [loading, setLoading] = useState(true);
    const [isOpenViewModal, setIsOpenViewModal] = useState(false);
    const [cradDetails, setCradDetails] = useState();
    const searchInputRef = useRef(null);
    const containerRef = useRef(null);
    const [moduleList, setModuleList] = useState([]);   

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            if (inputValue.trim().length > 0) {
                setCustomPlaeHoder(false);
            } else {
                setCustomPlaeHoder(true);
            }
        }
    };
    
    useEffect(()=> {
        if(Array.isArray(moduleList) && moduleList.length){
            getSelectedModuleCardDetails(selectedIndex)
        }
    }, [moduleList])

    useEffect(()=> {
        const selectedList = moduleData.filter(li => selectedModuleIds.includes(li.id));
        setModuleList(selectedList)
    }, [moduleData])

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [inputValue]);

    const getSelectedModuleCardDetails = (index) => {
        getSelectedModulecardDetails(moduleList[index]?.id, (response, err, errorCode) => {
            setLoading(true);
            if (err) {
                console.log(err);
                setLoading(false);
            } else {
                let resp = response.data;
                setLoading(false);
                setFilteredCard(resp);
            }
        })
    }

    const selectedCardHandler = (item) => {
        if(selectedIndex === item) return;
        setLoading(true);
        setSelectedIndex(item);
        getSelectedModuleCardDetails(item);
    }

    const getModulesByCondition = (condition) => {
        return filterdCard?.businessRules
          .filter(rule => rule.ruleCondition === condition)
          .flatMap(rule => rule.targetModules);
    };

    const handleCustomPlaceholder = () => {
        if(inputValue.trim().length > 0) {
            setCustomPlaeHoder(false);
        } else {
            setCustomPlaeHoder(true);
        }
    }

    const handleChangesearchfields = (e) => {
        if (e.target.value.trim().length > 0) {
        setCustomPlaeHoder(false);
        } else {
        setCustomPlaeHoder(true);
        }
        setInputValue(e.target.value);
    };

    const handleOnEnter = (e) => {
        if (e.key === "Enter") {
            setCustomPlaeHoder(false);
        //   onClickedSearch();
        }
    };

    const handleInputClick = () => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
            setCustomPlaeHoder(true);
        }
    };

    const handleSpanClick = () => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    };

    const getCardDetails = (id) => {
        getModuleCardDetails(id, (response, err, errorCode) => {
            setLoading(true);
            if (err) {
                console.log(err);
                setLoading(false);
            } else {
                let resp = response.data;
                setLoading(false);
                setCradDetails(resp);
                setIsOpenViewModal(!isOpenViewModal);
            }
        });
    }
    const viewModuleDetails = (e, details, type) => {
        let id = type === "leftView" ? details.id  : details.targetModuleId;
        e.stopPropagation();
        getCardDetails(id);
    }

    const closeViewDetailsModal = () => {
        setIsOpenViewModal(false);
    };

    return (
        <>
        {loading && (
            <CircularProgressBar
              isloading={loading}
              setIsloading={setLoading}
            />
        )}
        <div className='selected-module-content-modal'>
            <div className='d-flex selected-module-content-section'>
                <div className="selected-module-content-left-section">
                    <div className='selected-module-content'>
                        <h2 className='selected-module-content-heading'>SELECTED MODULES</h2>
                        <div className="d-flex g-0 selected-module-content-search-field" ref={containerRef}>
                            <img
                                alt="search"
                                src={LibrarySearchIcon}
                                className={"selected-module-content-search-icon"}
                            />
                            {customPlaceholder && (
                                <div
                                    className="selected-module-content-custom-placeholder"
                                    onClick={handleCustomPlaceholder}
                                >
                                    <span onClick={handleSpanClick} className='selected-module-content-placeholder'>Search by</span>
                                    <span onClick={handleSpanClick} className='selected-module-content-module-name' > ‘Module name / ID’</span>
                                </div>
                            )}
                            <input
                                value={inputValue}
                                type="text"
                                name="searchInput"
                                className="selected-module-content-search-input"
                                autoComplete="off"
                                onKeyDown={handleOnEnter}
                                // onClick={handleInputClick}
                                onChange={(e) => handleChangesearchfields(e)}
                                ref={searchInputRef}
                            />
                        </div>
                    </div>
                    <div className='selected-module-content-left-sec-main'>
                        {moduleList?.filter((item) =>
                                item.moduleDamName?.toLowerCase().includes(inputValue.toLowerCase()) ||
                                item.moduleName?.toLowerCase().includes(inputValue.toLowerCase())
                            )?.map((li, index) => (
                            <div className={`selected-module-content-left-sec ${selectedIndex === index ? "selected-module-content-left-sec-active-card" : "selected-module-content-left-sec-deactive-card" }`} onClick={() => selectedCardHandler(index)}>
                                <div className='d-flex'>
                                    {li?.componentUrl ? 
                                        <div className='selected-module-content-left-sec-image'>
                                            <img src={li.componentUrl} className='img-fluid selected-module-content-left-sec-img' width={48} height={42} alt="" />
                                        </div>
                                        :
                                        <div className='module-list-card-img-not-found-content'>
                                            <img src={EmptyImage} alt="" className='img-fluid'/>
                                        </div>
                                    }
                                    <div className='d-flex justify-content-between align-items-start' style={{width: "100%"}}>
                                        <div className='d-grid' style={{rowGap: "10px", marginLeft: "16px"}}>
                                            <div className='d-flex align-items-center'>
                                                <img src={li?.mlrStatus === "Available for Use" ? GreenTickMark : NotApprovedImage} alt="" />
                                                <p className='selected-module-list-card-moduleName'>{li?.moduleDamName}</p>
                                            </div>
                                            <div className='d-flex selected-module-card-brand-details'>
                                                <h4 className='selected-module-list-card-brand-name'>Name: </h4>
                                                <h2 className='selected-module-list-card-brand-content'>{li?.moduleName}</h2>
                                            </div>
                                        </div>
                                        <button className={`selected-module-list-left-card-view ${selectedIndex === index ? "selected-module-list-left-card-view-remove-bg" : "selected-module-list-left-card-view-add-bg" }`}  onClick={(e) => viewModuleDetails(e, li, 'leftView')}>VIEW</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {moduleList?.filter((item) =>
                                item.moduleDamName?.toLowerCase().includes(inputValue.toLowerCase()) ||
                                item.moduleName?.toLowerCase().includes(inputValue.toLowerCase())
                            )?.length===0 && <div style={{
                                fontWeight: 400,
                                fontSize: '12px',
                                color: '#54565b',
                                textAlign: 'center',
                                padding: '10px',
                            }}>No Module Found</div>}
                    </div>
                </div>
                <div className="selected-module-content-right-section">
                    <div className='row d-flex'>
                    {ruleCategories && ruleCategories?.map(category => {
                    // const filteredRules = moduleList && moduleList[0]?.moduleBusinessRules.filter(rule => rule.ruleCondition === category.condition);
                    const filteredModules = getModulesByCondition(category.condition);
                        return <div className='col-md-4' style={{padding:'0px 10px'}}>
                            <p className='selected-module-content-exist-list'>{category.label}<img src={InfoIcon}/></p>
                            <div className='selected-module-content-card' style={{background: "#F2F3F3"}}>
                                {filteredModules && filteredModules?.map((rule, idx) => (
                                    <div className='selected-module-content-area'>
                                        <div className='selected-module-wrapper-card'>
                                            <div className={`d-flex selected-module-content-right-sec ${rule?.targetModuleMlrStatus !== "Available for Use" ? 'selected-module-content-border-bottom' : ''}`}>
                                                {rule?.targetModuleComponentUrl ? 
                                                    <div className='selected-module-content-left-sec-image'>
                                                        <img src={rule?.targetModuleComponentUrl} className='img-fluid selected-module-content-left-sec-img' width={48} height={42} alt="" />
                                                    </div>
                                                    :
                                                    <div className='module-list-card-img-not-found-content'>
                                                        <img src={EmptyImage} alt="" className='img-fluid'/>
                                                    </div>
                                                }
                                                <div className='d-flex justify-content-between align-items-start' style={{width: "100%"}}>
                                                    <div className='d-grid' style={{rowGap: "10px", marginLeft: "12px"}}>
                                                        <div className='d-flex align-items-center'>
                                                            <img src={rule?.targetModuleMlrStatus === "Available for Use" ? GreenTickMark : NotApprovedImage} alt="" />
                                                            <p className='selected-module-list-card-moduleName'>{rule?.targetModuleDamName}</p>
                                                        </div>
                                                        <div className='d-flex selected-module-card-brand-details'>
                                                            <h4 className='selected-module-list-card-brand-name'>Name: </h4>
                                                            <h2 className='selected-module-list-card-brand-content'>{rule?.targetModuleName}</h2>
                                                        </div>
                                                    </div>
                                                    <button className='selected-module-list-left-card-view' onClick={(e) => viewModuleDetails(e, rule, 'rightView')}>VIEW</button>
                                                </div>
                                            </div>
                                            {rule?.targetModuleMlrStatus !== "Available for Use" && <h3 className='selected-module-cannot-approved'>This is not approved and cannot be used for authoring</h3>}
                                        </div>
                                    </div>
                                ))}
                                {filteredModules?.length <= 0 && <h3 className='selected-module-content-not-found'>No Module Found</h3>}
                            </div>
                        </div>
                    })}
                    </div>
                    <div className='row' style={{margin: "20px -4px 20px 0"}}>
                        <div className='selected-module-content-usage-guidelines'>
                            <p>Usage Guidelines</p>
                            <h3>These promotional modules are intended for health care professionals only</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {isOpenViewModal && (
            <ModuleView
                modulePreviewData={cradDetails}
                modulePreviewOpen={isOpenViewModal}
                setModulePreviewOpen={closeViewDetailsModal}
            />
        )}
        </>
    )
}

export default SelectedModuleModal;